"use client";

import { useEffect, useLayoutEffect } from "react";

/**
 * A hook that uses `useLayoutEffect` on the client and `useEffect` on the server.
 * This prevents the "useLayoutEffect does nothing on the server" warning in SSR environments.
 *
 * Use this instead of `useLayoutEffect` when:
 * - The component may be rendered on the server (SSR/SSG)
 * - You need synchronous DOM measurements or mutations after render
 *
 * @example
 * ```tsx
 * useIsomorphicLayoutEffect(() => {
 *   // Measure DOM elements here
 *   const width = ref.current?.getBoundingClientRect().width;
 * }, [dependency]);
 * ```
 */
export const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;
